import React from 'react';
import Marquee from 'react-fast-marquee';

export default function SystemAlert(props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {
  return (
    <div {...props}>
      <div className="container">
        <Marquee className="text-14 text-red-1 py-5 fw-500" speed={30}>
          Online Service : Booking system is not working under system maintenance / Every Tuesday 00:00 ~ 07:30(Japan Time) ※When Monday is public
          holiday, the maintenance is on Wednesday
        </Marquee>
      </div>
    </div>
  );
}
